import React, {Component, PropTypes} from 'react';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

class ThreeDotsMenu extends Component {

    constructor(props) {
        super(props);
        this.getMenuItems = this.getMenuItems.bind(this);
    }

    /**
     * Creates as much MenuItem(s) as there is in this.props.menuItems
     * 
     * @return Array of MenuItem
     */
    getMenuItems() {
        let items = this.props.menuItems;
        return items.map( (item, index) => <MenuItem key={index} {...item} /> );
    }

    render() {
        const menuItems = this.getMenuItems();

        return (
                <IconMenu
                iconButtonElement={<IconButton touch={true}><MoreVertIcon /></IconButton>}
                anchorOrigin={{horizontal: 'left', vertical: 'top'}}
                targetOrigin={{horizontal: 'left', vertical: 'top'}}
                {...this.props.menuProps}
                >
                    {menuItems}
                </IconMenu>
        );
    }
}

ThreeDotsMenu.propTypes = {
    menuItems: PropTypes.array.isRequired,
};

export default ThreeDotsMenu;





/** WEBPACK FOOTER **
 ** ./app-react/components/Menus/ThreeDotsMenu.jsx
 **/